module.exports = __webpack_public_path__ + "img/full5-min.f7bf6590.png";